import Logger from '$lib/utils/logger';
import { fetchNewsQuery, fetchQuery } from '..';
import {
  getNewsCategoriesQuery,
  getNewsDetailQuery,
  getRelatedNewsQuery,
  getVideoNewsQuery
} from '../queries/news';

export const getNewsCategories = async () => {
  try {
    const response = await fetchQuery(getNewsCategoriesQuery());
    const items = response?.data?.queryResult?.data?.swishNewsCategoriesCollection?.items;
    return items;
  } catch (error) {
    Logger.error('Error in getNewsCategories:', error);
    throw error;
  }
};

export const getNewsDetail = async (id: string) => {
  try {
    const response = await fetchQuery(getNewsDetailQuery(id));
    return response?.data?.queryResult?.data?.swishNewsContentful;
  } catch (error) {
    Logger.error('Error in getNewsDetail:', error);
    throw error;
  }
};

export const getRelatedNews = async (category: string, tags: string[] = [], limit = 5) => {
  try {
    const response = await fetchQuery(getRelatedNewsQuery(category, tags, limit));
    return response?.data?.queryResult?.data?.swishNewsContentfulCollection?.items;
  } catch (error) {
    Logger.error('Error in getRelatedNews:', error);
    throw error;
  }
};

export const getNewsFeed = async (
  page = 1,
  categories = [
    'Business',
    'Lifestyle',
    'Health',
    'Weather',
    'General',
    'Travel',
    'Entertainment',
    'Science',
    'World',
    'Technology',
    'Politics',
    'Sports'
  ]
) => {
  const params = {
    categories,
    page
  };
  try {
    const response = await fetchNewsQuery(params);
    return response?.data?.swishNewsContentfulCollection;
  } catch (error) {
    Logger.error('Error in getNewsFeed:', error);
    throw error;
  }
};

export const getNewsByCategory = async (category: string, page = 1) => {
  const params = {
    categories: [category],
    page
  };
  try {
    const response = await fetchNewsQuery(params);
    return response?.data?.swishNewsContentfulCollection;
  } catch (error) {
    Logger.error('Error in getNewsByCategory:', error);
    throw error;
  }
};

export const getVideoNews = async (skip = 0, limit = 20) => {
  try {
    const response = await fetchQuery(getVideoNewsQuery(skip, limit));
    return response.data.queryResult.data.swishNewsContentfulCollection?.items;
  } catch (error) {
    Logger.error('Error in getVideoNews', error);
    throw error;
  }
};
